var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHitachiLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 680.96 153.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: 680.96,
    height: 153.63
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M530.12,27.74c0,0,0,38.64,0,38.36h51.33c0,0.14-0.04-38.36,0-38.36c-0.04,0,25.16,0,25.42,0c0,0,0.09,95.84,0,95.95 c-0.03,0-25.38,0-25.42,0c0,0,0-42.1,0-42.22c0,0.12-51.33,0-51.33,0c0.04,0.16,0,42.25,0,42.22h-25.41c0,0,0.16-95.95,0-95.95 H530.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.94,27.74c0,0.29,0,16.33,0,16.33h-38.85v79.62h-25.42V44.07h-38.85c0,0,0.05-16.32,0-16.33 C185.87,27.76,288.94,27.74,288.94,27.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.29,44.07l-17.68,43.62h35.38L327.29,44.07 M387.72,123.69c0.06,0-28.49,0-28.29,0c0.04,0-8.33-20.63-8.33-20.63 h-47.62c0,0-8.17,20.65-8.32,20.63c0.02,0.02-28.28,0-28.28,0l44.83-95.95c0,0.06,31.17,0,31.17,0L387.72,123.69z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 626.99,
    y: 27.74,
    width: 25.43,
    height: 95.95
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.44,27.74c0,0-0.01,38.64,0,38.36h51.3c0,0.14-0.01-38.36,0-38.36c-0.01,0,25.15,0,25.43,0c0,0,0.06,95.84,0,95.95 c-0.03,0-25.41,0-25.43,0c0,0,0-42.1,0-42.22c0,0.12-51.3,0-51.3,0c0.01,0.16-0.01,42.25,0,42.22H29.02c0,0,0.14-95.95,0-95.95 H54.44"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.33,
    y: 27.74,
    width: 25.39,
    height: 95.95
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.81,97.09c-2.23-6.43-3.42-13.23-3.42-20.42c0-10.07,1.79-19.85,6.62-27.94c4.96-8.35,12.59-14.82,21.8-18.26 c8.79-3.29,18.24-5.11,28.16-5.11c11.41,0,22.23,2.5,32.07,6.77c9.16,3.93,16.09,12.2,18.12,22.17c0.41,1.97,0.74,4.01,0.91,6.05 h-26.67c-0.1-2.54-0.52-5.09-1.4-7.38c-2.01-5.31-6.42-9.42-11.91-11.09c-3.53-1.08-7.26-1.66-11.13-1.66 c-4.42,0-8.66,0.78-12.58,2.17c-6.5,2.28-11.59,7.55-13.87,14.06c-2.22,6.32-3.5,13.13-3.5,20.2c0,5.84,0.95,11.49,2.45,16.84 c1.91,7,7.16,12.61,13.86,15.15c4.26,1.59,8.83,2.55,13.63,2.55c4.1,0,8.04-0.63,11.76-1.83c4.96-1.57,9-5.25,11.11-9.96 c1.4-3.15,2.09-6.63,2.09-10.3h26.77c-0.15,3.11-0.58,6.21-1.28,9.11c-2.28,9.49-8.93,17.44-17.77,21.16 c-10.05,4.22-21.05,6.67-32.67,6.67c-8.99,0-17.65-1.42-25.77-3.97C401.81,118.17,391.07,109.25,386.81,97.09"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHitachiLogo);
export default __webpack_public_path__ + "static/media/hitachi-logo.ffeb0fa3559424943997b24264d0674d.svg";
export { ForwardRef as ReactComponent };